import { render, staticRenderFns } from "./BaseFormSwitch.vue?vue&type=template&id=c937e83a"
import script from "./BaseFormSwitch.vue?vue&type=script&lang=js"
export * from "./BaseFormSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports